import { createStyles } from "@mantine/core";
import { colors, pxToRem } from "theme";

export const commonStyles = createStyles((theme) => ({
  input: {
    border: `1px solid ${colors.grey[70]}`,
    borderRadius: pxToRem[2],
    "&:focus": {
      borderColor: theme.other.primary[60],
    },
  },
  inputErr: {
    border: `1px solid ${colors.red[40]}`,
    borderRadius: pxToRem[2],
    "&:focus": {
      borderColor: theme.colors.red[6],
    },
  },
}));
